module.exports = __webpack_public_path__ + "img/9.839b3c8b.jpg";